/*
 * @Author: 向南星 xiangnanxing@scmagic.cn
 * @Date: 2022-09-19 13:56:15
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-11-07 14:18:30
 */
import React from 'react';
import styles from './index.module.scss';
interface Props {
  value: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
  max?: number;
}
const NumberInput: React.FC<Props> = ({ value, onChange, max }) => {
  return (
    <span className={styles.container}>
      <input
        type="number"
        value={value}
        onChange={e => {
          if (max && Number(e.target.value) > max) {
            onChange(`${max}`);
          } else if (Number(e.target.value) <= 0) {
            onChange('0');
          } else {
            onChange(e.target.value.replace(/^0/, ''));
          }
        }}
      />
      <button
        type="button"
        onClick={() => onChange(v => `${Math.max(1, Number(v) - 1)}`)}
        className={styles.minus}
      />

      <button
        type="button"
        onClick={() =>
          onChange(v =>
            max ? `${Math.min(max, Number(v) + 1)}` : `${Number(v) + 1}`
          )
        }
        className={styles.plus}
      />
    </span>
  );
};

export default NumberInput;
